import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { createContext, useContext, useEffect, useState } from 'react';
import { useMutation } from '@apollo/client';
import { useMe } from '@crehana/auth';
import { cookies, customLocalStorage } from '@crehana/utils';
import { COOKIES_COMPASS_THEME_KEY } from "./constants";
import { jsx as _jsx } from "react/jsx-runtime";
var UPDATE_USER_THEME_PREFERENCE_MUTATION = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "UpdateUserThemePreference" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "darkMode" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } }, directives: [] }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createOrUpdateUserSettings" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "darkMode" }, value: { kind: "Variable", name: { kind: "Name", value: "darkMode" } } }] } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "success" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "messages" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "settings" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "darkMode" }, arguments: [], directives: [] }] } }] } }] } }], loc: { start: 0, end: 195, source: { body: "mutation UpdateUserThemePreference($darkMode: Boolean) {\n  createOrUpdateUserSettings(\n    input: { darkMode: $darkMode }\n  ) {\n    success\n    messages\n    settings {\n      darkMode\n    }\n  }\n}\n", name: "GraphQL request", locationOffset: { line: 1, column: 1 } } } };
var UIThemeContext = /*#__PURE__*/createContext({
  theme: 'light',
  isDark: false,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  toggleTheme: function toggleTheme() {}
});
export var UIThemeProvider = function UIThemeProvider(_ref) {
  var children = _ref.children;
  var _useMe = useMe(),
    me = _useMe.me;
  var initialTheme =
  // eslint-disable-next-line no-nested-ternary
  typeof window === 'undefined' ? 'light' : customLocalStorage.getItem('crehana-dark-mode') ? 'dark' : 'light';
  var _useState = useState({
      theme: initialTheme,
      isDark: initialTheme === 'dark'
    }),
    _useState2 = _slicedToArray(_useState, 2),
    _useState2$ = _useState2[0],
    theme = _useState2$.theme,
    isDark = _useState2$.isDark,
    setState = _useState2[1];
  var _useMutation = useMutation(UPDATE_USER_THEME_PREFERENCE_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 1),
    updateUserThemePreferenceMutation = _useMutation2[0];
  var toggleCompassTheme = function toggleCompassTheme(_ref2) {
    var _document$querySelect, _document$querySelect2, _document$querySelect3, _document$querySelect4, _document$querySelect5, _document$querySelect6;
    var to = _ref2.to;
    var add = to === 'light' ? 'tw-light' : 'tw-dark';
    var remove = to === 'light' ? 'tw-dark' : 'tw-light';
    (_document$querySelect = document.querySelector('html')) === null || _document$querySelect === void 0 ? void 0 : (_document$querySelect2 = _document$querySelect.classList) === null || _document$querySelect2 === void 0 ? void 0 : (_document$querySelect3 = _document$querySelect2.add) === null || _document$querySelect3 === void 0 ? void 0 : _document$querySelect3.call(_document$querySelect2, add);
    (_document$querySelect4 = document.querySelector('html')) === null || _document$querySelect4 === void 0 ? void 0 : (_document$querySelect5 = _document$querySelect4.classList) === null || _document$querySelect5 === void 0 ? void 0 : (_document$querySelect6 = _document$querySelect5.remove) === null || _document$querySelect6 === void 0 ? void 0 : _document$querySelect6.call(_document$querySelect5, remove);
  };
  useEffect(function () {
    if (me !== null && me !== void 0 && me.settings) {
      var darkMode = me.settings.darkMode;
      setState({
        theme: darkMode ? 'dark' : 'light',
        isDark: !!darkMode
      });
    }
  }, [me]);
  useEffect(function () {
    if (isDark) {
      customLocalStorage.setItem('crehana-dark-mode', 'true');
      toggleCompassTheme({
        to: 'dark'
      });
      cookies.setCookie(COOKIES_COMPASS_THEME_KEY, 'dark', 365 * 5);
    } else {
      customLocalStorage.removeItem('crehana-dark-mode');
      toggleCompassTheme({
        to: 'light'
      });
      cookies.setCookie(COOKIES_COMPASS_THEME_KEY, 'light', 365 * 5);
    }
  }, [isDark]);
  var toggleTheme = function toggleTheme(args) {
    var _ref3 = args || {},
      _ref3$shouldSaveTheme = _ref3.shouldSaveThemePreferenceMutation,
      shouldSaveThemePreferenceMutation = _ref3$shouldSaveTheme === void 0 ? true : _ref3$shouldSaveTheme;
    var newTheme = theme === 'light' ? 'dark' : 'light';
    var darkMode = newTheme === 'dark';
    setState({
      theme: newTheme,
      isDark: darkMode
    });
    if (shouldSaveThemePreferenceMutation) {
      updateUserThemePreferenceMutation({
        variables: {
          darkMode: darkMode
        }
      });
    }
  };
  return /*#__PURE__*/_jsx(UIThemeContext.Provider, {
    value: {
      theme: theme,
      isDark: isDark,
      toggleTheme: toggleTheme
    },
    children: children
  });
};
export var useUITheme = function useUITheme() {
  var context = useContext(UIThemeContext);
  if (context === undefined) {
    throw new Error('useUITheme must be used within a UITheme provider. To include it with LayoutV2, the prop withUITheme must be true.');
  }
  return context;
};
export default UIThemeProvider;